import React from "react";
import Privacy from "./sections/PrivacyPolicy";

export default function PrivacyPage ({data}) {
    return(
        <>
            <Privacy data={data}></Privacy>
        </>
    )
}